import {Action, ActionReducerMap} from '@ngrx/store';
import {
    PAGE_STATE_RESET,
    PageStateResetAction
} from './vorlage-auswaehlen.actions.ui';
import { APP_RESET_ACTION } from '@orga-app/appstart/actions';
import {GET_INCIDENT_VORLAGEN_LISTE, GET_INCIDENT_VORLAGEN_LISTE_ERFOLGREICH, GET_INCIDENT_VORLAGEN_LISTE_FEHLER, GetIncidentVorlagenListeErfolgreichAction} from '../../../../client-ngrx/incidents';
import {IncidentVorlageDetail} from '../../../../clients/incidents';

export interface ModuleState {
    page: PageState;
}

export const reducers: ActionReducerMap<ModuleState> = {
    page: pageReducer
};

export interface PageState {
    vorlagen: Array<IncidentVorlageDetail>;
    vorlagenLaden: boolean;
    vorlagenFehler: boolean;

    selectedVorlagenId: string;
}

export const initialPageState: PageState = {
    vorlagen: [],
    vorlagenLaden: false,
    vorlagenFehler: false,

    selectedVorlagenId: null
};

export function pageReducer(state = initialPageState, action: Action): PageState {
    switch (action.type) {
        // Page State Reset
        case APP_RESET_ACTION: {
            return Object.assign({}, state, <PageState> initialPageState);
        }

        // Page State Reset
        case PAGE_STATE_RESET: {
            const a = <PageStateResetAction> action;

            return Object.assign({}, state, <PageState> initialPageState);
        }

        // Liste der Vorlagen
        case GET_INCIDENT_VORLAGEN_LISTE: {
            return Object.assign({}, state, <PageState> {
                vorlagenLaden: true,
                vorlagenFehler: false
            });
        }

        case GET_INCIDENT_VORLAGEN_LISTE_ERFOLGREICH: {
            const a = <GetIncidentVorlagenListeErfolgreichAction> action;

            return Object.assign({}, state, <PageState> {
                vorlagen: a.payload,
                vorlagenLaden: false,
                vorlagenFehler: false
            });
        }

        case GET_INCIDENT_VORLAGEN_LISTE_FEHLER: {
            return Object.assign({}, state, <PageState> {
                vorlagen: [],
                vorlagenLaden: false,
                vorlagenFehler: true
            });
        }

        default: {
            return state;
        }
    }
}




